import styled from 'styled-components'

export const Notch = styled.div`
	position: absolute;
	width: 24px;
	height: 4px;
	top: 8px;
	left: calc(50% - 12px);
	background-color: #c8c8c8;
	border-radius: 2px;
`
